import React from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"
import { useMicroCopyFi } from "../../hooks/microCopy"
import GetMicroCopy from "../../shared/getMicroCopy"
import Button from "../../components/button"

const TeaserCard = ({ image, title, url, boxed, text, children }) => {
    
const microCopyTexts = useMicroCopyFi
const labelReadMore = GetMicroCopy(microCopyTexts, "yleinenLueLisää")

  return (
    <article className={`${boxed ? "bg-white" : ""} flex flex-col`}>
      <div className="relative">
        {image && (
          <div className="relative h-0 pb-[40%] md:pb-[56.25%] mb-4 ">
            <GatsbyImage
              className="w-full h-full !absolute top-0 left-0"
              image={image}
              alt=""
            />
          </div>
        )}
        <div className={`${boxed ? "px-5" : ""} `}>
          <h3 className="font-sans-medium mb-0">
            <div
              className=""
            >
              {title}
            </div>
          </h3>
          {text && <p className="mt-5">{text}</p>}
          <Button externalUrl={url} label={labelReadMore + " " + title} secondary> {labelReadMore}</Button>
        </div>
      </div>
      {children && <div className={`${boxed ? "px-5" : ""} `}> {children}</div>}
    </article>
  )
}

TeaserCard.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.object,
  url: PropTypes.string,
  boxed: PropTypes.bool,
  children: PropTypes.node,
  text: PropTypes.string,
}

export default TeaserCard
